__turbopack_context__.v({
  "container": "Notification-module__PRozea__container",
  "error": "Notification-module__PRozea__error",
  "icon": "Notification-module__PRozea__icon",
  "info": "Notification-module__PRozea__info",
  "maps": "Notification-module__PRozea__maps",
  "success": "Notification-module__PRozea__success",
});
